type CaseTypes = "space" | "kebab" | "title" | "sentence" | "pascal" | "camel"

export function spaceCase(str: string) {
    return str
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/[\s_]+/g, " ")
        .replace(/[\s-]+/g, " ")
        .toLowerCase()
}

export function kebabCase(str: string) {
    return str
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/[\s_]+/g, "-")
        .toLowerCase()
}

export function snakeCase(str: string) {
    return str
        .replace(/([a-z])([A-Z])/g, "$1_$2")
        .replace(/[\s-]+/g, "_")
        .toLowerCase()
}

export function titleCase(str: string) {
    return str
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/[\s_]+/g, " ")
        .replace(/[\s-]+/g, " ")
        .replace(/\b\w/g, (letter) => letter.toUpperCase())
}

// The case where it is like this: Hello World
export function sentenceCase(str: string) {
    return str
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/[\s_]+/g, " ")
        .replace(/[\s-]+/g, " ")
        .replace(/\b[a-z]/g, (letter, index) =>
            index === 0 || str[index - 1] !== "'" ? letter.toUpperCase() : letter
        )
}

export function pascalCase(str: string) {
    return str
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/[\s_]+/g, " ")
        .replace(/[\s-]+/g, " ")
        .replace(/\b\w/g, (letter) => letter.toUpperCase())
        .replace(/\s/g, "")
}

export function camelCase(str: string) {
    return str
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/[\s_]+/g, " ")
        .replace(/[\s-]+/g, " ")
        .replace(/\b\w/g, (letter, index) => (index === 0 ? letter.toLowerCase() : letter.toUpperCase()))
        .replace(/\s/g, "")
}

export function specialCase(menuName: string, caseType?: CaseTypes): string {
    const specialWords: Record<string, string> = {
        "a-la-carte": "À La Carte",
        "dine-la-dinner": "Dine LA Dinner",
        "dine-la-lunch": "Dine LA Lunch",
        "breakfast-to-go": "Breakfast To-Go"
    }

    if (specialWords[menuName]) return specialWords[menuName]

    switch (caseType) {
        case "space":
            return spaceCase(menuName)
        case "kebab":
            return kebabCase(menuName)
        case "title":
            return titleCase(menuName)
        case "sentence":
            return sentenceCase(menuName)
        case "pascal":
            return pascalCase(menuName)
        case "camel":
            return camelCase(menuName)
        default:
            return titleCase(menuName)
    }
}